import { render, staticRenderFns } from "./LogoYara.vue?vue&type=template&id=a25c39cc"
import script from "./LogoYara.vue?vue&type=script&lang=js"
export * from "./LogoYara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports